import PropTypes from "prop-types";
import getPartnerFulfilsFulfilmentStrings from "../getPartnerFulfilsFulfilmentStrings";

const PartnerFulfilsFulfilmentStringsMarkup = ({ labelledById, seller }) => {
  const { dtc_seller_info_label, sellerDescription } =
    getPartnerFulfilsFulfilmentStrings({ seller });

  return (
    <span id={labelledById} aria-hidden={true}>
      {dtc_seller_info_label} <strong>{sellerDescription}</strong>
    </span>
  );
};

PartnerFulfilsFulfilmentStringsMarkup.propTypes = {
  labelledById: PropTypes.string.isRequired,
  seller: PropTypes.shape({
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  })
};

export default PartnerFulfilsFulfilmentStringsMarkup;
